import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ paths }) => {
  return (
    <div className="flex items-center">
      <div className="border-t-[1.5px] border-neutral-300 2xl:w-[18%] 2xl:mr-12 mr-5"></div>

      <div className="flex items-center xl:text-xl tracking-wider">
        {paths.map((path, index) => (
          <div className="flex items-center" key={index}>
            {index !== 0 && <span className="mx-2">/</span>}
            {index === paths.length - 1 ? (
              <span className="text-neutral-400 cursor-not-allowed">
                {path.label}
              </span>
            ) : (
              <Link
                to={path.link}
                className="text-neutral-800 hover:text-primary transition-colors ease-in-out duration-300"
              >
                {path.label}
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb;
